import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Typography } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from '../AuthProvider';
import FetchTradeJobs from './service/FetchTradeJobs';
import CalendarView from './views/CalendarView';
import TradeJobFormView from './views/TradeJobFormView';

export default function TradeJobCalendarPage() {
  const auth = useAuth();
  const currentUserId = auth?.additionalUserInfo?.id;

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingJob, setEditingJob] = useState(null);

  const fetchJobs = useCallback(async () => {
    if (!auth?.token) return;
    setLoading(true);
    try {
      const data = await FetchTradeJobs(auth.token);
      setJobs((Array.isArray(data) ? data : []).map((job) => ({ ...job, key: job.id || uuidv4() })));
    } catch (err) {
      console.error('Failed to load trade jobs for calendar:', err);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  }, [auth?.token]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const openEditJob = (job) => {
    setEditingJob(job);
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setEditingJob(null);
  };

  return (
    <div style={{ padding: 16 }}>
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        Trade Job Calendar
      </Typography.Title>

      <CalendarView
        jobs={jobs}
        loading={loading}
        onRefresh={fetchJobs}
        onEditJob={openEditJob}
        currentUserId={currentUserId}
      />

      <TradeJobFormView
        open={isFormOpen}
        onClose={closeForm}
        onSaved={fetchJobs}
        token={auth?.token}
        additionalUserInfo={auth?.additionalUserInfo}
        initialJob={editingJob}
      />
    </div>
  );
}
